import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
};

const AlertIcon = ({ size = 50, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 50 50" fill="none" {...props}>
            <rect x="24.7485" y="1.41421" width="33" height="33" rx="5" transform="rotate(45 24.7485 1.41421)" stroke={color} strokeWidth="2" />
            <rect x="24" y="16" width="2" height="12" fill={color} />
            <rect x="24" y="31" width="2" height="2" fill={color} />
        </svg>
    );
};

export default AlertIcon;
